import { initials } from '@/lib/format'
import { cn } from '@/lib/cn'

interface AvatarProps {
  name: string
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const SIZES = {
  sm: 'h-8 w-8 text-[11px]',
  md: 'h-10 w-10 text-xs',
  lg: 'h-14 w-14 text-base',
}

/** Awatar z inicjałami — system nie przechowuje zdjęć użytkowników. */
export function Avatar({ name, size = 'md', className }: AvatarProps) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-full',
        'bg-primary/10 font-bold text-primary',
        SIZES[size],
        className,
      )}
    >
      {initials(name)}
    </span>
  )
}
